import Query from '../utils/Query';

export default class SettingsService {

	static fetch() {
		return Query.get('/items/settings', {
			single: 1
		});
	}
}
